import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '~/eds/src/components/Button/Button';
import { useIntl } from 'react-intl';

import EcModalCard from '../../Shared/EcModalCard/EcModalCard';

function SendPasswordEmailModal({
  confirmButtonText,
  text,
  title,
  hideModal,
  resetPassword,
}) {
  const intl = useIntl();

  const handleActionClick = () => {
    resetPassword();
    hideModal();
  };

  return (
    <EcModalCard
      title={title}
      content={text}
      footer={
        <>
          <Button
            variant="tertiary"
            text={intl.formatMessage({
              id: 'SendPasswordEmailModal.cancelButton',
              defaultMessage: 'Cancel',
              description: 'Cancel button text',
            })}
            onClick={hideModal}
          />
          <Button
            variant="primary"
            text={confirmButtonText}
            onClick={handleActionClick}
          />
        </>
      }
      hideModal={hideModal}
    />
  );
}

SendPasswordEmailModal.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.object.isRequired,
  confirmButtonText: PropTypes.string.isRequired,
  hideModal: PropTypes.func.isRequired,
};

export default SendPasswordEmailModal;
